import { http } from '../http';

type SignatureStrokeUrlResponse = {
	success: boolean;
	uploadUrl: string;
	keyName: string;
	fields: {
		key: string;
		'x-amz-algorithm': string;
		'x-amz-credential': string;
		'x-amz-date': string;
		'x-amz-security-token': string;
		'x-amz-signature': string;
		policy: string;
	};
};

function isSignatureStrokeUrlResponse(
	value: unknown,
): value is SignatureStrokeUrlResponse {
	if (!value || typeof value !== 'object') {
		return false;
	}

	const obj = value as Record<string, unknown>;

	// Check top-level properties
	if (typeof obj.success !== 'boolean') {
		return false;
	}

	if (typeof obj.uploadUrl !== 'string') {
		return false;
	}

	if (typeof obj.keyName !== 'string') {
		return false;
	}

	// Check fields object
	if (!obj.fields || typeof obj.fields !== 'object') {
		return false;
	}

	const fields = obj.fields as Record<string, unknown>;

	// Check all required fields properties
	const requiredFieldKeys = [
		'key',
		'x-amz-algorithm',
		'x-amz-credential',
		'x-amz-date',
		'x-amz-security-token',
		'x-amz-signature',
		'policy',
	];

	for (const key of requiredFieldKeys) {
		if (typeof fields[key] !== 'string') {
			return false;
		}
	}

	return true;
}

export async function getSignatureStrokeUploadUrl(certificateSerial: string) {
	const signatureStrokeUrlResponse = await http.post<{
		data: SignatureStrokeUrlResponse;
	}>(`documents/upload-signature-stroke-url`, {
		cert_serial: certificateSerial,
	});
	if (isSignatureStrokeUrlResponse(signatureStrokeUrlResponse)) {
		return signatureStrokeUrlResponse;
	} else {
		throw TypeError;
	}
}
